import { createNewOrganizationUid, PaymentPlanUids, } from "@buildwithflux/models";
import { isCypressTestUserAgent } from "@buildwithflux/shared";
import { LRUCache } from "lru-cache";
import { StorageSubscriptionManager } from "../subscriptions";
const CacheMaxEntries = 100;
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const CacheTTL = 1000 * 60 * 5;
export class OrganizationRepository {
    subscriptionMgr = new StorageSubscriptionManager();
    byUidCache = new LRUCache({
        max: CacheMaxEntries,
        ttl: CacheTTL,
    });
    /**
     * Get a organization object by UID.
     */
    async getByUid(organizationUid, { cache } = { cache: true }) {
        if (cache && this.byUidCache.has(organizationUid)) {
            return this.byUidCache.get(organizationUid);
        }
        const byUid = await this.getByUidWithoutCache(organizationUid);
        if (byUid) {
            this.byUidCache.set(organizationUid, byUid);
        }
        else {
            this.byUidCache.delete(organizationUid);
        }
        return byUid;
    }
    /**
     * Returns a newly created in-memory (not yet persisted) copy of the entities that will be persisted when the
     * requested organization data is saved for the first time
     */
    getCreationData({ organizationData, ownerUser, belongsToEnterprise, }) {
        const uid = createNewOrganizationUid();
        const organization = {
            // TODO: zod to remove stray properties?
            ...organizationData,
            uid,
            enterpriseUid: belongsToEnterprise,
            updatedAt: Date.now(),
            createdAt: Date.now(),
            partsCount: 0,
            documentsCount: 0,
            isTest: isCypressTestUserAgent(),
        };
        if (belongsToEnterprise) {
            organization.activeProductUid = PaymentPlanUids.organizationEnterprise;
        }
        const member = {
            organizationUid: uid,
            enterpriseUid: belongsToEnterprise,
            userUid: ownerUser.uid,
            userHandle: ownerUser.handle,
            visibility: organizationData.visibility,
            role: "owner",
            createdAt: Date.now(),
            updatedAt: Date.now(),
        };
        const handleMapping = organizationData.visibility !== "private"
            ? {
                organizationUid: uid,
                user_uid: undefined,
                userHandle: organizationData.handle,
            }
            : undefined;
        return {
            organization,
            member,
            handleMapping,
        };
    }
    /**
     * Notify all listeners of a change.
     */
    notifyOrganizationChangeListeners(uid, change) {
        this.subscriptionMgr.notify(uid, change);
    }
}
//# sourceMappingURL=OrganizationRepository.js.map